import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';

const useStyles = makeStyles(() => {
  const theme = useTheme();

  return {
    footer: {
      backgroundColor: '#00171F',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: 'white',
    },
    content: {
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: '1200px',
      paddingBottom: '20px',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
      },
    },
    buttons: {
      color: 'white',
      outline: 'transparent',
      backgroundColor: 'transparent', // Fondo transparente
      boxShadow: 'none', // Sin sombras
      '&:hover': {
        color: 'white', // Cambia el color del texto al pasar el mouse
        backgroundColor: 'transparent', // Mantener el fondo transparente en hover
      },
    },
    buttonsDiv: {
      display: 'flex',
      gap: '15px',
      alignItems: 'center',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
    logoDiv: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    socialIcons: {
      color: 'white',
      display: 'flex',
      gap: '10px',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        justifyContent: 'center',
      },
    },
    divider: {
      width: '100%',
      border: '0.5px solid #243C53',
    },
    bottomText: {
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: '1200px',
      color: '#243C53',
      [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
        alignItems: 'center',
        gap: '5px',
      },
    },
    leftText: {
      fontSize: '18px',
      color: 'white',
      textAlign: 'left',
      [theme.breakpoints.down('lg')]: {
        textAlign: 'center',
      },
    },
    rightText: {
      fontSize: '18px',
      color: 'white',
      textAlign: 'right',
      textDecoration: 'underline',
      cursor: 'pointer',
      [theme.breakpoints.down('lg')]: {
        textAlign: 'center',
      },
    },
  };
});

export default useStyles;
